<template>
  <div v-if="ecItemList">
    <h2>{{ title }}</h2>
    <div class="d-flex">
      <v-col cols="3" class="pa-2" v-for="item in ecItemList" :key="item">
        <router-link :to="{ name: 'ecItemContent', query: { ecitem_id: item.ec_item_id, title: item.ec_item_name } }" class="text-decoration-none">
          <div class="store_pickup__thumbnail elevation-2"
            :style="{ backgroundImage: `url(/data/ec/${item.ec_item_id}/main.jpg)` }">
          </div>
        </router-link>
      </v-col>
    </div>
  </div>
</template>

<style scoped>
.store_pickup__thumbnail {
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #cacaca;
}
</style>

<script>
import axios from "axios"

export default {
  name: 'EcItemListCircle',
  props: {
    title: {
      type: String,
      default: ''
    },
    item_id: {
      type: Number,
      default: 0
    },
    endpoint: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    ecItemList: [],
  }),
  async mounted() {
    const response = await axios.get(this.endpoint, {
      params: {
        item_id: this.item_id,
      }
    }).catch((error) => {
      console.log(error)
      return;
    });
    console.log(response.data)
    this.ecItemList = response.data;
  }
}
</script>